import script from "./AgreementDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementDialog.vue?vue&type=script&setup=true&lang=js"

import "./AgreementDialog.vue?vue&type=style&index=0&id=3ca1584a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca1584a"]])

export default __exports__